import React, { useState, useContext } from "react";
import { Box, Input, Text, useToast } from "@chakra-ui/react";
import { ProductsContext } from "../../Context/ProductsContext";
import FormModal from "../../Common/FormModal";

const AddBrand = ({ isOpen, setIsOpen }) => {
  const [newBrand, setNewBrand] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [newBrandValidation, setNewBrandValidation] = useState();
  const { addBrand } = useContext(ProductsContext);
  const toast = useToast();

  const handleSubmitBrand = async () => {
    setIsSubmitting(true);
    if (newBrand.length === 0) {
      setNewBrandValidation("Ingrese un nombre");
      setIsSubmitting(false);
      return false;
    }
    setNewBrandValidation("");
    try {
      await addBrand(newBrand);
      setNewBrand("");
      setIsOpen(false);
      toast({
        title: "Categoria agregada con éxito.",
        status: "success",
        duration: 4000,
        isClosable: true,
      });
    } catch (e) {
      toast({
        title: "Se ha producido un error.",
        description: e,
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
    setIsSubmitting(false);
  };

  return (
    <FormModal
      title={"Agregar nueva marca"}
      action={() => handleSubmitBrand(newBrand)}
      isModalOpen={isOpen}
      setIsModalOpen={setIsOpen}
      isSubmitting={isSubmitting}
    >
      <Box w="100%" mr="1">
        <Input
          placeholder={"Ingrese una nueva marca"}
          value={newBrand}
          isInvalid={newBrandValidation}
          errorBorderColor="red.300"
          onChange={(e) => setNewBrand(e.target.value)}
        ></Input>
        {newBrandValidation ? (
          <Text color="red.300">{newBrandValidation}</Text>
        ) : null}
      </Box>
    </FormModal>
  );
};

export default AddBrand;
